import { Drawer, Image, Layout, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { Icons, Images } from '../../../controller/Images';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import { Role } from '../../../controller/enum';
const { Sider } = Layout;

// const menuItem = [
//   ({
//     name: 'user',
//     iconColor: <Image src={Icons.userColorIcon} alt='' width={23} height={25} preview={false} />,
//     iconwithoutColor:<Image src={Icons.usermutedIcon} alt='' width={23} height={25} preview={false} />,
//     url:routes.admin.dashboard.user.self
//   }),
//   {
//     name: 'candidate',
//     iconColor: <Image src={Icons.candidateColorIcon} alt='' width={23} height={25} preview={false} />,
//     iconwithoutColor:<Image src={Icons.candidatemutedIcon} alt='' width={23} height={25} preview={false} />,
//     url:routes.admin.dashboard.candidates
//   },
//   {
//     name: 'questionnaire',
//     iconColor: <Image src={Icons.questionaireColorIcon} alt='' width={23} height={25} preview={false} />,
//     iconwithoutColor:<Image src={Icons.questionairemutedIcon} alt='' width={23} height={25} preview={false} />,
//     url:routes.admin.dashboard.questionnaire.self
//   },
//   {
//     name: 'test',
//     iconColor: <Image src={Icons.testColorIcon} alt='' width={23} height={25} preview={false} />,
//     iconwithoutColor:<Image src={Icons.testmutedIcon} alt='' width={23} height={25} preview={false} />,
//     url:routes.admin.dashboard.test.self
//   },
//   {
//     name: 'invitation',
//     iconColor: <Image src={Icons.invitationColorICon} alt='' width={23} height={25} preview={false} />,
//     iconwithoutColor:<Image src={Icons.invitationmutedIcon} alt='' width={23} height={25} preview={false} />,
//     url:routes.admin.dashboard.invitation
//   },
// ];

const AdminSidebar = ({ toggleDrawer, drawerVisible }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSideModule,setActiveSideModule]=useState("candidate")
  let data = getAdminDetail()
  const menuItem = [
//  (data?.role == Role.organization&&{
//       name: 'organization',
//       iconColor: <Image src={Icons.orgwithColorICon} className='green-icon' alt='' width={23} height={25} preview={false} />,
//       iconwithoutColor:<Image src={Icons.orgwithoutColorICon} alt='' width={23} height={25} preview={false} />,
//       url:routes.admin.dashboard.organization.self
//     }),
    ((data?.role == Role.organization||data?.role == Role.admin)&&{
      name: 'user',
      iconColor: <Image src={Icons.userColorIcon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.usermutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.user.self
    }),
    {
      name: 'candidate',
      iconColor: <Image src={Icons.candidateColorIcon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.candidatemutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.candidates
    },
    {
      name: 'questionnaire',
      iconColor: <Image src={Icons.questionaireColorIcon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.questionairemutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.questionnaire.self
    },
    {
      name: 'test',
      iconColor: <Image src={Icons.testColorIcon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.testmutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.test.self
    },
    {
      name: 'invitation',
      iconColor: <Image src={Icons.invitationColorICon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.invitationmutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.invitation
    },
    {
      name: 'profile',
      iconColor: <Image src={Icons.invitationColorICon} className='green-icon' alt='' width={23} height={25} preview={false} />,
      iconwithoutColor:<Image src={Icons.invitationmutedIcon} alt='' width={23} height={25} preview={false} />,
      url:routes.admin.dashboard.profile
    },
  ];
  useEffect(() => {
    const currPath=location.pathname.split('/')
    setActiveSideModule(currPath[2])
  }, [location]);

  const SidebarMenuItem = () => {
    return (
      <div className='d-flex flex-column gap-3 mt-5'>
        {menuItem?.map((val, index) => (
          <div
            key={index}
            onClick={()=>{
              navigate(val.url)
            }}
            style={{cursor:'pointer'}}
            className={`w-100 fw-bold rounded-3 p-2 text-capitalize ${activeSideModule==val.name?"text-color-custom sidebar-item-background-color":"text-muted"}`}
          >
            {console.log(activeSideModule,"dkndndk",val?.name)}
            <div className='d-flex align-items-center gap-3'>
              {activeSideModule==val?.name?val.iconColor:val.iconwithoutColor}
              {val.name}
            </div>
          </div>
        ))}
      </div>
    );
  };
  return (
    <>
      <Sider
        className='bg-white border-end p-4 d-flex flex-column d-lg-block d-sm-none responsive-sidebar '
        // breakpoint='md'
        // collapsedWidth={0}
        // collapsed={sidebar}
        // onCollapse={setSidebar}
      >
        <div className='w-100 d-flex justify-content-center align-items-center'> 
        <Image
          src={data?.organization_id?.logo||Images.logo}
          alt=''
          className='logo'
          width={'auto'}
          height={40}
          preview={false}
        />
        </div>
        <SidebarMenuItem />
      </Sider>
      <Drawer
        title=''
        placement='left'
        closable={false}
        onClose={toggleDrawer}
        open={drawerVisible}
      >
         <CloseOutlined
            className='d-flex align-items-end justify-content-end'
            onClick={() => toggleDrawer()}
          />
         <div className='w-100 d-flex justify-content-center align-items-center'> 
        <Image
          src={data?.organization_id?.logo||Images.logo}
          alt=''
          className='logo'
          width={'auto'}
          height={40}
          preview={false}
        />
        </div>
        <SidebarMenuItem />
      </Drawer>
    </>
  );
};

export default AdminSidebar;
